import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../dave-utils-module/app-button-module/app-button.module';
import { ChartOfAccountEntity } from '../../dave-data-module/entities/chart-of-Account.entity';
import { CustomerSpecificationTypeEntity } from '../../dave-data-module/entities/customerSpecificationType.entity';

@Component({
    selector: 'app-edit-customerspecificationtype',
    standalone: true,
    imports: [CommonModule, AppButtonModule, FontAwesomeModule, MatTooltipModule],
    templateUrl: './edit-customerspecificationtype.component.html',
    styleUrls: ['./edit-customerspecificationtype.component.scss'],
})
export class EditCustomerspecificationtypeComponent  {
    @Input()  public CustomerSpecificationType: CustomerSpecificationTypeEntity;
    @Output() editEvent = new EventEmitter<CustomerSpecificationTypeEntity>();

    constructor() {}

    onEditClick( event: CustomerSpecificationTypeEntity ) {
        this.editEvent.emit(event);
    }
    get isButtonDisabled(): boolean {
        return this.CustomerSpecificationType?.PartnerId === null;
    }
}
